module.exports = __webpack_public_path__ + "media/images/icon__profile@3x-8b5504335e7f9b2397df09da12318eb2.png";